import { Outlet } from "react-router";

export default function Layout() {
	return (
		<>
			<Outlet></Outlet>
		</>
	);
}
